import generateMD5Checksum from './generateMD5Checksum';

const generateChecksum = (fileOrUint8) => {
  return fileOrUint8.arrayBuffer().then((buffer) => generateMD5Checksum(new Uint8Array(buffer)));
};

export default generateChecksum;
